import {
  PARTICIPANT_TYPES,
  ORGANIZATION_TYPES,
  IDENTITY_REQUEST_TYPES
} from '@/constants/business'

const organizationMixin = {
  methods: {
    getRequestTypeByOrganization: function (organizationType, participantType, isEIO) {
      if (!organizationType || !participantType) {
        return null
      }
      if (organizationType === ORGANIZATION_TYPES.INDIVIDUAL) {
        if (isEIO) {
          return participantType === PARTICIPANT_TYPES.ORGPART
            ? IDENTITY_REQUEST_TYPES.PARTICIPANT_INDIVIDUAL_ORGANIZATION_AS_EIO
            : IDENTITY_REQUEST_TYPES.INDIVIDUAL_ORGANIZATION_AS_EIO
        } else {
          return participantType === PARTICIPANT_TYPES.ORGPART
            ? IDENTITY_REQUEST_TYPES.PARTICIPANT_INDIVIDUAL_ORGANIZATION
            : IDENTITY_REQUEST_TYPES.INDIVIDUAL_ORGANIZATION
        }
      } else {
        if (isEIO) {
          return participantType === PARTICIPANT_TYPES.ORGPART
            ? IDENTITY_REQUEST_TYPES.PARTICIPANT_LEGAL_ORGANIZATION_AS_EIO
            : IDENTITY_REQUEST_TYPES.LEGAL_ORGANIZATION_AS_EIO
        } else {
          return participantType === PARTICIPANT_TYPES.ORGPART
            ? IDENTITY_REQUEST_TYPES.PARTICIPANT_LEGAL_ORGANIZATION
            : IDENTITY_REQUEST_TYPES.LEGAL_ORGANIZATION
        }
      }
    }
  }
}

export default organizationMixin
